module.exports = __webpack_public_path__ + "img/图层 21.d53b6dc1.png";